/* eslint-disable @typescript-eslint/no-explicit-any */
import { XrangePointOptionsObject } from 'highcharts';
import { FailureGradeCell } from '@Types/failureGrade.types';

export const generateRangeLabels = (boundaryRanges: string[], reverse?: boolean): string[] => {
	const rangeLabels: string[] = [];

	if (boundaryRanges.length === 0) {
		return [];
	}

	for (const range of boundaryRanges) {
		rangeLabels.push(range);
	}

	if (!reverse) return rangeLabels;
	else return rangeLabels.reverse();
};

export const legendsColors = {
	negligible: '#3B82F6',
	low: '#14B8A6',
	medium: '#F59E0B',
	high: '#EC4899',
	extreme: '#8B5CF6',
};

export const gradeDisplayNames: Record<string, string> = {
	negligible: 'optimal',
	low: 'stable',
	medium: 'moderate',
	high: 'concerning',
	extreme: 'critical',
};

export const legends = [
	{ name: 'negligible', displayName: 'optimal', color: legendsColors.negligible },
	{ name: 'low', displayName: 'stable', color: legendsColors.low },
	{ name: 'medium', displayName: 'moderate', color: legendsColors.medium },
	{ name: 'high', displayName: 'concerning', color: legendsColors.high },
	{ name: 'extreme', displayName: 'critical', color: legendsColors.extreme },
];

export const buildPieChartData = (
	matrix: FailureGradeCell[][],
	t: (key: string) => string,
): XrangePointOptionsObject[] => {
	const gradeCounts = matrix.flat().reduce<Record<string, number>>((acc, { grade, count }) => {
		acc[grade] = (acc[grade] || 0) + count;
		return acc;
	}, {});

	return Object.entries(gradeCounts).map(([grade, count]) => ({
		y: count,
		name: t(gradeDisplayNames[grade] ?? grade).toUpperCase(),
		color: legendsColors[grade as keyof typeof legendsColors],
	}));
};
